import TeacherIndex from '@/views/teachers/TeacherIndex.vue';
import AddTeacher from '@/views/teachers/AddTeacher.vue';
import EditTeacher from '@/views/teachers/EditTeacher.vue';
import TeacherAttendanceIndex from '@/views/teachers/attendances/TeacherAttendanceIndex.vue';
import RecordTeacherAttendance from '@/views/teachers/attendances/RecordTeacherAttendance.vue';
import EditTeacherAttendance from '@/views/teachers/attendances/EditTeacherAttendance.vue';

export default [
  {
    path: '/teachers',
    name: 'teachers.index',
    component: TeacherIndex,
    meta: { 
      title: 'teachers.indexTitle',
      requiresAuth: true,
      requiredPerm: 'teachers.display',
    },
    children: [
      {
        path: '/teachers/create',
        name: 'teachers.create',
        component: AddTeacher,
        meta: { 
          title: 'teachers.addTitle', 
          requiresAuth: true,
          requiredPerm: 'teachers.create',
        }
      },
      {
        path: '/teachers/:id/edit',
        name: 'teachers.edit',
        component: EditTeacher,
        props: true,
        meta: { 
          title: 'teachers.editTitle', 
          requiresAuth: true,
          requiredPerm: 'teachers.update',
        }
      }
    ]
  },
  {
    path: '/teacher-attendances',
    name: 'teacher-attendances.index',
    component: TeacherAttendanceIndex,
    meta: { 
      title: 'teacherAttendances.indexTitle',
      requiresAuth: true,
      requiredPerm: 'teacher_attendance.display',
    },
    children: [
      {
        path: '/teacher-attendances/record',
        name: 'teacher-attendances.record',
        component: RecordTeacherAttendance,
        meta: { 
          title: 'teacherAttendances.recordTitle', 
          requiresAuth: true,
          requiredPerm: 'teacher_attendance.create',
        }
      },
      {
        path: '/teacher-attendances/edit/:id',
        name: 'teacher-attendances.edit',
        component: EditTeacherAttendance,
        props: true,
        meta: { 
          title: 'teacherAttendances.editTitle', 
          requiresAuth: true,
          requiredPerm: 'teacher_attendance.update',
        }
      }
    ]
  },
];
